<template>
  <div class="welcome-banner px-4 pt-4">
    <div class="welcome-banner__wrapper pa-6">
      <div class="text-center">
        <span class="welcome-banner__title text-center headline-1">{{ $t("Welcome to WIDE") }}</span>
        <img class="ml-1" src="/img/welcome-hand.png" alt="welcome-hand" />
      </div>
      <div class="welcome-banner__subtitle text-center caption mt-2">{{ $t("Let’s get you started!") }}</div>
      <div class="welcome-banner__actions mt-6">
        <base-button
          class="welcome-banner__btn __discover subtitle-3 px-3"
          outline
          @click="$router.push({ name: 'discover' })"
          >{{ $t("DISCOVER CREATORS") }}</base-button
        >
        <base-button
          class="welcome-banner__btn __become subtitle-3 px-3"
          @click="$router.push({ name: 'profilePayeeInfo' })"
          >{{ $t("BECOME A CREATOR") }}</base-button
        >
      </div>
      <base-icon-button color="var(--palette-unchanged-bg)" class="welcome-banner__close" @click="$emit('close', true)"
        >sci-close</base-icon-button
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseIconButton from "@/components/BaseIconButton";
export default defineComponent({
  name: "WelcomeBanner",
  components: { BaseButton, BaseIconButton },
});
</script>

<style scoped lang="scss">
.welcome-banner {
  background-color: var(--palette-gray-lighten-7);
  &__wrapper {
    position: relative;
    border-radius: 14px;
    background: linear-gradient(90deg, #1d1d1d 0%, #464646 100%);
  }
  &__title,
  &__subtitle {
    color: var(--palette-unchanged-bg);
  }
  &__close {
    position: absolute;
    top: 0;
    right: 0;
  }
  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: var(--sp-3);
    justify-content: center;
    @include mobile-only {
      justify-content: center;
    }
  }
  &__btn {
    width: 254px;
    min-width: auto;
    @include mobile-only {
      width: 100%;
    }
    &.__discover {
      border-color: var(--palette-unchanged-bg);
      color: var(--palette-unchanged-bg);
    }
    &.__become {
      background: var(--palette-bg);
      color: var(--palette-fg);
    }
  }
}
</style>
